import { TripOutput } from '@allocab/allocab-passenger-shared-types';

import onRoadImage from '../../../assets/images/on_road.png';
import { t } from '../../../services/translation/translation';
import { dateAdd, formatDateForParisTZ } from '../../../utils/date';

interface Props {
  trip: TripOutput;
}

export const OnDuty = ({ trip }: Props) => {
  const arrivalDate = trip.driver?.etaBeforeDropOff
    ? dateAdd(Date.now(), trip.driver.etaBeforeDropOff, 'minutes')
    : null;

  return (
    <div className="flex justify-between items-center gap-x-2">
      <div className="flex-col flex w-full">
        <strong>{t('share-route.trip-detail.onduty')}</strong>
        {arrivalDate ? (
          <span>
            {`${t('share-route.trip-detail.estimated-arrival')} ${formatDateForParisTZ(
              arrivalDate.valueOf(),
              'HH:mm',
            )}`}
          </span>
        ) : null}
      </div>
      <img alt="onroad" className="h-8" src={onRoadImage} />
    </div>
  );
};
